module.exports = __webpack_public_path__ + "img/BackgroundImg.be2eaecc.png";